import { Address } from 'features/profile/types/address.types';
import { UpdateUser, User } from 'features/profile/types/user.types';
import { nullToStringObjectValue, toJalali } from 'utils/utils';
import { LegalObject } from '../legal.form';
import { IdentityObject } from '../identity.form';
import { AddressObject } from '../address.form';

export const transformProfileObjectToRegisterFields = (
    profile?: User,
    addresses?: Address[],
): UpdateUser => {
    return nullToStringObjectValue({
        ...LegalObject(profile ? profile : undefined),
        ...IdentityObject(
            profile
                ? {
                      ...profile,
                      birth: profile.birth ? toJalali(profile.birth) : '',
                  }
                : undefined,
        ),
        ...AddressObject(
            addresses
                ? {
                      ...addresses[0],
                      address_type: addresses[0]?.type ?? 'home',
                  }
                : undefined,
        ),
        signatures: profile?.opts?.signatures || [],
        refered: profile?.reffered || '',
        name: profile?.name,
        type: profile?.type === 'person' ? 'person' : 'company',
    });
};
